module.exports = __webpack_public_path__ + "static/Kunto-58640044ddd7d515916428d4424d84cf.png";